import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import appdownloadicon from "../assets/images/header-appdownload-icon.svg"
import headerserviceicon from "../assets/images/header-service-icon.svg"
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import apiPath from "../Utils/apiPath";
import {
  MdArrowBackIosNew,
  MdKeyboardArrowLeft,
  MdOutlineRefresh,
  MdOutlineSubject,
} from "react-icons/md";
import MenuSidebar from "./MenuSidebar";
import MenuSidebarNew from "./MenuSidebarNew";
import { HiOutlineRefresh } from "react-icons/hi";
import { useTranslation } from "react-i18next";
// import bajiApk from "/baji247.apk";
import crose from "../assets/images/cross-black.svg";
//  import downloadapp from "../assets/images/favicon.ico";
import logoutImg from "../assets/images/logout.svg";
import bournemouth from "../assets/images/bournemouth.png";
import bologna from "../assets/images/bologna.png";
import { IoMdSettings } from "react-icons/io";
import MessageBox from "./MessageBox";
import { apiGet } from "../Utils/apiFetch";

const HeaderNew = () => {
  const {
    user,
    user_coins,
    setUserCoins,
    handleShowSidebar,
    showSidebar,
    amounutRefresh,
    refreshAmountLoader,
    userCoins,
    loginUser,
    setShowDownloadBar,
    downloadBar,
    logoutUser,
    setOpenBetsToogle,
    setSettingToogle,
    settingToogle
  } = useContext(AuthContext);
  const navigate = useNavigate()
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(false);
  const [showMultiWallet, setShowMultiWallet] = useState(false); // State to control wallet visibility

  const getCoins = async () => {
    if (isEmpty(user)) return;

    setRefresh(true);

    try {
      const { status, data } = await apiGet(apiPath.refreshAmount);

      if (status === 200 && data?.success) {
        const { exposure, totalCoins } = data.results || {};

        // Prevent unnecessary re-render
        setUserCoins((prev) =>
          prev?.exposure === exposure && prev?.totalCoins === totalCoins
            ? prev
            : { exposure, totalCoins }
        );
      }
    } catch (error) {
      console.log("getCoins error:", error);
    } finally {
      setRefresh(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      getCoins();
    }
  }, [user]);

  const SIX_SECOND_MS = 6000;

  useEffect(() => {
    if (!isEmpty(user)) {
      const interval = setInterval(() => {
        getCoins();
      }, SIX_SECOND_MS);

      return () => clearInterval(interval);
    }
  }, [user]);

  // Toggle function for multi wallet
  const toggleMultiWallet = () => {
    setShowMultiWallet(!showMultiWallet);
  };

  // Function to close multi wallet when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const multiWalletDiv = document.getElementById('multiWalletDiv');
      const multiWalletButton = document.getElementById('multiWallet');
      
      if (showMultiWallet && multiWalletDiv && !multiWalletDiv.contains(event.target) && !multiWalletButton.contains(event.target)) {
        setShowMultiWallet(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMultiWallet]);

  return (
    <>
      {/* {
      downloadBar && 
      <div class="download-bar">
        <img width="15" height="15" src={crose} alt="download" class="mr-2 crose-icon" onClick={() => setShowDownloadBar(false)}/>
          <img width="32" height="32" src={downloadapp} alt="download" class="mr-2 c-radis" />
            <div class="mr-1 col">
              <b>{t("DOWNLOAD_APP")}</b>
            </div>
            <button data-v-3b7d3367="" type="button" class="pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default download-bar-button subtitle-1">
              <a class="v-btn__content" href={"#"} download="Melbet" target='_blank'>DOWNLOAD</a>
              </button>
    </div>
    } */}
      {isEmpty(user) ? (<div className="login-header-new">
        <div className="login-reg-wrapper">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              className="bg-transparent border-0 text-white"
              onClick={() => handleShowSidebar()}
            >
              <MdOutlineSubject className="fs-4" style={{ color: '#fff' }} />
            </button>
            <figure onClick={() => navigate("/")}>
              {/* {isEmpty(user) ? (
            <img
              style={{
                height: "50px",
              }}
              src={logo}
              alt=""
            />):  */}
              <img
                style={{
                  height: "auto",
                  maxWidth: "130px"
                }}
                src={logo}
                alt=""
              />
              {/* } */}
              {/*<div class="hd-spon hd-spon--ani">
              <ul class="hd-spon__icon">
                <li>
                  <img src={bournemouth} alt="icon-sponsor" class="spon-icon" />
                  <img src={bologna} alt="icon-sponsor" class="spon-icon" />
                </li>
                <li>
                  <img src={bologna} alt="icon-sponsor" class="spon-icon" />
                  <img src={bournemouth} alt="icon-sponsor" class="spon-icon" />
                </li>
              </ul>
            </div> */}
            </figure>
          </div>
          {isEmpty(user) ? (
            <div className="newcssadd">
              <div className="header-btn">
                {/* <a
                  href="https://agentsbook.bet/"
                  target="_blank"
                  className="btn-signup ui-link"
                >
                  Agent List
                </a> */}
                <Link className="login-index ui-link" to="/login">
                  Login
                </Link>
              </div>
            </div>


          ) : (
            


            <div className="align-items-lg-start for-ref after-login">
              {refreshAmountLoader ? (
                <div class="loader-outer">
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: "0s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".1s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".2s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".3s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".4s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".5s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".6s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".7s" }}
                  ></span>
                </div>
              ) : (
                <>
                  {/* <div className="header-blance-block">
                    <div className="header-blance">
                      <div className=""
                      style={{display:'flex', alignItems:'center', justifyContent:'space-between', minHeight:'110px'}}>
                        <div className="" style={{display:'block'}}>
                        <span style={{display:'block'}}>{user?.user?.username}</span>
                        <span>BDT: {userCoins?.totalCoins?.toFixed()} Exp 0.00</span>
                        </div>
                        <div className="header-right-box">+5</div>
                      </div>
                      <div className="refresh_blance-box"><MdOutlineRefresh /></div>
                    </div>
                    <div className="setting_block">
                      <IoMdSettings />
                    </div>
                  </div> */}
                  {/* <div class="desktop-log-reg">
                    <span className="v-btn__content3" onClick={() => logoutUser()} title="Logout"><img src={logoutImg} /></span>

                  </div> */}
                </>
              )}
            </div>
          )}
          {/*<div className="header-right-btn-group">
          
            <a href={bajiApk}  download="Baji247 App" target='_blank'><img src={appdownloadicon} /><span>App</span></a>
            <a href="#"><img src={headerserviceicon}/><span >Help</span></a>
            </div>*/}
        </div>

      </div>
      ) : (
        <div className="style09 headerMain1-block">
          <header id="headerMain1" style={{
            position: ' fixed',
            zIndex: ' 99', width: '100%', left: '0'
          }}>
            <MessageBox />
            <ul>
              <li className="li-tv_bet">
                <button className="btnshowsidebar border-0 text-white"
                  onClick={() => handleShowSidebar()}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 24 24"
                    className="fs-4"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z" />
                  </svg>
                </button>
                <a
                  id="openBetsBtn"
                  className="a-open_bets ui-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenBetsToogle(true);
                  }}
                  href="#open-bets"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="https://baji24.com/assets/images/transparent.gif  "
                    alt=""
                  />
                  Bets
                </a>
              </li>

              <li className="main-wallet">
                <a id="multiWallet" className="a-wallet ui-link" onClick={toggleMultiWallet}> {/* Added onClick handler */}
                  <ul id="accountCredit">
                    <li>
                      <span id="betCredit">{user?.user?.username}</span>
                    </li>
                    <li>
                      <span> PBU </span>{userCoins?.totalCoins?.toFixed(2) || userCoins?.balance?.toFixed(2)} <span> Exp</span>{" "}
                      <span
                        id="totalExposure"
                        style={{ background: "0px center", padding: 2, backgroundColor:"red", borderRadius:"3px" }}
                      >
                        {/* {let exposureVal = userCoins?.exp || userCoins?.exposure } */}
                        {userCoins?.exp?.toFixed(2) || userCoins?.exposure?.toFixed(2)}
                      </span>
                    </li>
                    <li className="nums">
                      +<span id="vendorQuantity">5</span>
                    </li>
                  </ul>
                </a>
                <a
                  className="a-refresh ui-link"
                  id="menuRefresh"
                  title="Refresh Main Wallet"
                  onClick={() => getCoins()}
                >
                  <img
                    src="https://baji24.com/assets/images/transparent.gif  "
                    alt=""
                  />
                </a>
              </li>
              <li>
                <a
                  className="a-setting ui-link"
                  title="Setting"
                  onClick={(e) => {
                    e.preventDefault();
                    setSettingToogle(!settingToogle);
                  }}
                  href="#setting"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="https://baji24.com/assets/images/transparent.gif  "
                    alt=""
                  />
                </a>
              </li>
            </ul>
            <div id="multiWalletDiv" className={`overlay ${showMultiWallet ? '' : 'hide-wallet'}`} style={{ display: showMultiWallet ? "block" : "none" }}> {/* Dynamic style based on state */}
              <div className="wallet-detail">
                <div className="wallet-detail-group">
                  <dl className="wallet-detail-content">
                    <dt>Main Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="currency">
                        PBU
                      </span>
                      <span id="mainBalance">115.02</span>
                    </dd>
                    <dd className="wallet-exposure">
                      Exposure{" "}
                      <span id="mainExposure" className="red">
                        ( 0.00)
                      </span>
                    </dd>
                  </dl>
                </div>
                <div id="walletContent" className="wallet-detail-group">
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_6">International Casino Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_6">
                        Casino Exposure
                      </span>
                      <span id="vendorBalance_6" className="red">
                        0
                      </span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_6"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_1">Casino Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_1">
                        PBU
                      </span>
                      <span id="vendorBalance_1"> </span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_1"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_3">BPoker Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_3">
                        PBU
                      </span>
                      <span id="vendorBalance_3">0 Points</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_3"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_5">SABA Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_5">
                        PBU
                      </span>
                      <span id="vendorBalance_5">0</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_5"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_4">Sky Trader Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_4">
                        PBU
                      </span>
                      <span id="vendorBalance_4">0</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_4"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="recallAllDl" className="wallet-detail-content">
                    <dd className="align-R">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recallAll"
                      >
                        Recall All
                      </button>
                    </dd>
                  </dl>
                </div>
                <div
                  id="walletTemp"
                  className="wallet-detail-group"
                  style={{ display: "none" }}
                >
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle">Housie Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency">
                        PBU
                      </span>
                      <span id="vendorBalance">$ 0.00</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="recallAllDl" className="wallet-detail-content">
                    <dd className="align-R">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recallAll"
                      >
                        Recall All
                      </button>
                    </dd>
                  </dl>
                </div>
                <div className="btn-box" onClick={toggleMultiWallet}>
                  <button
                    className="btn ui-btn ui-shadow ui-corner-all"
                    id="balanceClose"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </header>

        </div>
      )}

      {showSidebar && (
        <MenuSidebarNew
          cancelMenu={handleShowSidebar}
          showSidebar={showSidebar}
        />
      )}

      {showSidebar && (
        <div className="overlay" onClick={() => handleShowSidebar()}></div>
      )}


    </>
  );
};

export default HeaderNew;